import {
  Calendar,
  CheckCircle,
  Clock,
  Eye,
  Info,
  MapPin,
  Sliders,
  Star,
} from "@tamagui/lucide-icons";
import type { LearnAboutInfo } from "../LearnScreen";

export const LocationLearnMore: LearnAboutInfo[] = [
  {
    titleIcon: Calendar,
    title: "Locations",
    subtitle: "Find out the groups favorite location",
    image: require("../../../../web_legacy/static/location_card_preview.webp"),
    featureList: [
      {
        icon: MapPin,
        text: "1. Add your own favorite locations",
      },
      {
        icon: Clock,
        text: "2. Wait for everyone to do the same",
      },
      {
        icon: Star,
        text: "3. Rate all locations (1-5) using stars",
      },
      {
        icon: CheckCircle,
        text: "4. Decide where to go based on the ratings",
      },
      {
        icon: Eye,
        text: "5. See the final location on the overview",
      },
    ],
    descriptions: [
      {
        icon: Info,
        title: "What is it?",
        description:
          "Cast votes on locations, see all options on a map, and let the group's preferences lead the way to the perfect location with Planira's Location card.",
      },
      {
        icon: Sliders,
        title: "Extra options",
        description:
          "For every location you can set a description, making it easier for the rest of the group to know how to vote.",
      },
    ],
  },
];
